import { getIssuePriority } from 'shared/constants/issues';
import {
  IssueTitleColumn,
  OrderTimeColumn,
  CompleteTimeColumn,
  EmergencyColumn,
  WageColumn,
  ViewColumn,
} from 'views/Wages/commonColumns';

export const getDetailedTableData = (paidWageData, selectedDoctorId) => {
  const paidWage = paidWageData.filter(
    (item) => item.user.id === selectedDoctorId
  );

  const tableData = paidWage.map((wage) => {
    const {
      id,
      issueCreatedAt,
      createdAt,
      issueId,
      issueTitle,
      issuePriority,
      originalWage,
      currentWage,
      starred,
    } = wage;

    return {
      issueTitle: issueTitle,
      emergency: getIssuePriority(issuePriority),
      orderTime: issueCreatedAt,
      completeTime: createdAt,
      wage: {
        originalWage: originalWage,
        currentWage: currentWage,
      },
      view: {
        wageId: id,
        issueId: issueId,
      },
      flag: starred,
    };
  });
  return tableData;
};

export const getDetailedTableColumns = (goToIssueDetails) => {
  return [
    IssueTitleColumn(),
    EmergencyColumn(),
    OrderTimeColumn(),
    CompleteTimeColumn(),
    WageColumn(),
    ViewColumn(goToIssueDetails),
  ];
};
